import { CheckCheck } from 'lucide-react'

import type { TimelineNote } from '@/api/types/overland'
import { formatTimeJST } from '@/lib/activity-format-utils'

/** 「ここまで確認」を押した記録（note_type="review"）の1行表示 */
export const ReviewEventRow = ({ note }: { note: TimelineNote }) => (
  <div className="flex items-center gap-1.5 px-1 text-xs text-muted-foreground">
    <CheckCheck className="size-3.5 text-emerald-500" />
    <span>{formatTimeJST(note.timestamp)}</span>
    <span>アクティビティを確認（{note.content}）</span>
  </div>
)
